import { useCallback } from 'react';
import { useUpdateMappings } from '../../../../../services/hooks/useMappingsActions';
import { MappingsEventType } from '../../../../Mappings/MappingsGrid/mappingsGridEvents';
import { ReasonForChange } from '../../../../Mappings/forms/reasons-for-change';

export interface DomainEditArgs {
  providerRecordId: number;
  companyId: number;
  newDomain: string;
}

export function useDomainEdit(): (args: DomainEditArgs) => Promise<boolean> {
  const updateMappings = useUpdateMappings();
  return useCallback(
    async ({ providerRecordId, companyId, newDomain }) => {
      const primary = newDomain || null;
      // Null primary omits `reason` → BE's remove-website branch (runs cleanupCompanyProviderData).
      // With a reason, provider rows for the old domain would be orphaned.
      const config = primary === null ? undefined : { params: { reason: ReasonForChange.rebrand } };
      const result = await updateMappings(
        { id: providerRecordId, companyId, primary },
        MappingsEventType.editPrimary,
        config
      );
      return result !== null;
    },
    [updateMappings]
  );
}
